import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Loader2 } from "lucide-react";
import { Seo } from "@/components/Seo";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: active === "all" ? {} : { category: active } })
      .then((r) => setProducts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [active]);

  const tabs = ["all", ...categories];

  return (
    <div className="mx-auto max-w-7xl px-6 py-14">
      <Seo
        title="Shop Organic Inputs"
        path="/shop"
        description="Browse certified-organic fertilisers, pest control, neem oil and soil care from Yayra Glover Organic Inputs. Priced in GHS, cash on delivery across Ghana."
      />
      <div className="max-w-2xl">
        <span className="text-xs uppercase tracking-[0.2em] text-brand-muted font-semibold">Catalog</span>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl text-brand">Organic Inputs Shop</h1>
        <p className="mt-3 text-brand-muted">Certified organic fertilisers, pest control, seeds and soil care — priced in Ghana Cedis.</p>
      </div>

      <div className="mt-10 flex flex-wrap gap-2" data-testid="category-filters">
        {tabs.map((c) => (
          <button key={c} data-testid={`filter-${c}`} onClick={() => setActive(c)}
            className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${active === c ? "bg-brand text-white border-brand" : "bg-white text-brand-muted border-brand/15 hover:border-brand/40"}`}>
            {c === "all" ? "All Products" : c}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="py-24 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-brand" /></div>
      ) : products.length === 0 ? (
        <p className="py-24 text-center text-brand-muted">No products found.</p>
      ) : (
        <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="products-grid">
          {products.map((p, i) => <ProductCard key={p.product_id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
